import createEnum from 'scripts/lib/create_enum';

const AttachmentSourceType = createEnum('SNIPPET', 'UPLOAD');

export default AttachmentSourceType;
